import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import Loadable from 'react-loadable'

import NotFound from './pages/NotFound'
import HomeLayout from './layout/HomeLayout'
import SiteLayout from './layout/SiteLayout'
import IndexPage from './pages/IndexPage'

import Universal from './universal/Universal'

const Loading = () => (
  <div>Loading</div>
)

const LoadableLogin = Loadable({
  loader: () => import(`./pages/Login`),
  loading: Loading,
})

const LoadableSignup = Loadable({
  loader: () => import(`./pages/Signup`),
  loading: Loading,
})

const LoadableForgetPwd = Loadable({
  loader: () => import(`./pages/ForgetPwd`),
  loading: Loading,
})

const LoadableHomePage = Loadable({
  loader: () => import(`./pages/Home`),
  loading: Loading,
})

const LoadableEditMsg = Loadable({
  loader: () => import(`./pages/EditMsg`),
  loading: Loading,
})

const LoadableLoginLog = Loadable({
  loader: () => import(`./pages/LoginLog`),
  loading: Loading,
})

const LoadablePayLog = Loadable({
  loader: () => import(`./pages/PayLog`),
  loading: Loading,
})

const LoadableAboutUs = Loadable({
  loader: () => import(`./pages/AboutUs`),
  loading: Loading,
})

const LoadableGoods = Loadable({
  loader: () => import(`./pages/Goods`),
  loading: Loading,
})

const SiteRoutes = () => (
  <Switch>
    <Route path="/login" component={LoadableLogin}></Route>
    <Route path="/signup" component={LoadableSignup}></Route>
    <Route path="/forget_password" component={LoadableForgetPwd}></Route>
    <Route path="/" component={IndexPage} exact></Route>
    <Route path="/*" component={NotFound} exact></Route>
  </Switch>
)

const HomeRoutes = () => (
  <Universal>
    <Switch>
      <PrivateRoute path="/home/user" component={LoadableHomePage}></PrivateRoute>
      <PrivateRoute path="/home/profile_update" component={LoadableEditMsg}></PrivateRoute>
      <PrivateRoute path="/home/login_log" component={LoadableLoginLog}></PrivateRoute>
      <PrivateRoute path="/home/purchase_log" component={LoadablePayLog}></PrivateRoute>
      <PrivateRoute path="/home/about_us" component={LoadableAboutUs}></PrivateRoute>
      <PrivateRoute path="/home/view_goods" component={LoadableGoods}></PrivateRoute>
      <PrivateRoute path="/home" component={LoadableHomePage}></PrivateRoute>
    </Switch>
  </Universal>
)


const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/home" component={HomeLayout}></Route>
      <Route path="/" component={SiteLayout}></Route>
      <Route path="*" component={NotFound}></Route>
    </Switch>
  </BrowserRouter>
)

export { Routes, SiteRoutes, HomeRoutes }



// WEBPACK FOOTER //
// ./src/Route.js